import { Component, inject, ViewChild } from '@angular/core';
import { InputType } from '@app/enum/input-type';
import { QuestionComponent } from '@app/components/shared/form/question/question.component';
import { BranchService } from '@app/services/branch/branch.service';
import { ActivatedRoute } from '@angular/router';
import { EmptySearchComponent } from '@app/components/empty-search/empty-search.component';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { ListComponent } from '@app/components/global/list/list.component';
import { FormGroup } from '@angular/forms';
import { QuestionBase } from '@app/models/question-base';
import { QuestionControlService } from '@app/services/question/question-control.service';
import { TextboxQuestion } from '@app/models/questions/question-textbox';
import { SchedulerStepService } from '@app/services/step/scheduler-step.service';


@Component({
  selector: 'app-products-list',
  standalone: true,
  providers: [QuestionControlService],
  imports: [
    QuestionComponent,
    ListComponent,
    EmptySearchComponent
  ],
  templateUrl: './branchs-list.component.html',
})
export class BranchsListComponent extends BaseConfigurableComponent{

  @ViewChild(QuestionComponent) questionComponent!: QuestionComponent;

  protected branchService = inject( BranchService )
  private readonly qcs = inject(QuestionControlService)
  protected schedulerService = inject( SchedulerStepService );

  questions: QuestionBase<string>[] = [this.FormSearch]

  inputType : typeof InputType = InputType
  target: string = ''

  form: FormGroup = this.qcs.toFormGroup(this.questions as QuestionBase<string>[]);

  constructor(override route: ActivatedRoute) {
    super('page')
    this.schedulerService.branchSelected.set({} as Branch)
    this.route.data.subscribe(data => {
      this.target = data['target']
    });
  }

  resetSearch(): void {
    this.questionComponent.resetSearch();
  }

  get FormSearch() {
    return new TextboxQuestion ({
      key: 'search',
      search: true,
      placeholder: this.getText().branch.input.search,
      order: 1
    })
  }

  selectEvent(event: { function: string; value: string | CategorySelected | Branch}): void {
    if (event.function === 'selectBranch'){
      this.schedulerService.branchSelected.set(event.value as Branch)
      this.schedulerService.searchQuery.set('')
    }
  }

}